import {useEffect, useState} from "react";

import {filterSidebarConfig} from "./search.utils";
import {useNavConfig} from "../../sidebar/useNavConfig";

export function useSearchItem(selectedTerms) {
    const navConfig = useNavConfig();
    const [search, setSearch] = useState(selectedTerms);
    const [itemsCount, setItemsCount] = useState(0);
    const [totalCount, setTotalCount] = useState(0);
    const [filteredSidebarConfig, setFilteredSidebarConfig] = useState([]);

    useEffect(() => {
        const {sidebarConfig: filteredSidebarConfig, count, totalCount} = filterSidebarConfig(search, navConfig);

        setItemsCount(count);
        setTotalCount(totalCount);
        setFilteredSidebarConfig(filteredSidebarConfig);

    }, [search]);

    return {
        search, setSearch, filteredSidebarConfig, itemsCount, totalCount
    }
}